import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useMutation } from '@apollo/client/react';
import { CREATE_OR_UPDATE_BOARD } from '../../graphql/boards';
import BoardForm from './BoardForm';

const BoardModal = ({ open, onClose, board, onSave }) => {
  const [createOrUpdateBoard] = useMutation(CREATE_OR_UPDATE_BOARD);

  const handleSave = async (formData) => {
    if (!formData.name?.trim()) {
      return null;
    }
    
    try {
      const variables = {
        name: formData.name,
        start_date: formData.startDate || null,
        end_date: formData.endDate || null
      };

      if (board) {
        variables.id = board.id;
      }

      const { data } = await createOrUpdateBoard({ variables });
      if (onSave) {
        await onSave(data?.createOrUpdateBoard?.board);
      }
      
      onClose();
    } catch (error) {
      console.error('Error saving board:', error);
      return null;
    }
  };

  if (!open) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {board ? 'Edit Board' : 'Create New Board'}
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <BoardForm
          board={board}
          onSave={handleSave}
          onCancel={onClose}
        />
      </DialogContent>
    </Dialog>
  );
};

export default BoardModal;
